import React from 'react';
import { useTheme } from 'styled-components';

import { IIconProps } from './TIcon';

type Props = IIconProps & {
  filled?: boolean;
};

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function VPPIcon({ color: colorProp, filled = false }: Props) {
  const theme = useTheme();

  const color = colorProp || theme.colors.chartChartBlueSecondary2100;

  return filled ? (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5872_15818)">
        <path
          d="M6.5 1.33203C6.5 0.778906 6.94688 0.332031 7.5 0.332031H8.5C9.05313 0.332031 9.5 0.778906 9.5 1.33203V3.33203H12V1.83203C12 1.55703 12.225 1.33203 12.5 1.33203C12.775 1.33203 13 1.55703 13 1.83203V3.33203H13.4937H13.5031H15V1.83203C15 1.55703 15.225 1.33203 15.5 1.33203C15.775 1.33203 16 1.55703 16 1.83203V3.33203C16 3.88516 15.5531 4.33203 15 4.33203H13.6719L9.5 7.57578V15.832C9.5 16.107 9.275 16.332 9 16.332C8.725 16.332 8.5 16.107 8.5 15.832V7.33828V7.32891V4.33203H7.5V7.32891V7.33828V15.832C7.5 16.107 7.275 16.332 7 16.332C6.725 16.332 6.5 16.107 6.5 15.832V7.57578L2.32812 4.33203H1C0.446875 4.33203 0 3.88516 0 3.33203V1.83203C0 1.55703 0.225 1.33203 0.5 1.33203C0.775 1.33203 1 1.55703 1 1.83203V3.33203H2.49688H2.50625H3V1.83203C3 1.55703 3.225 1.33203 3.5 1.33203C3.775 1.33203 4 1.55703 4 1.83203V3.33203H6.5V1.33203ZM3.95625 4.33203L6.5 6.31016V4.33203H3.95625ZM9.5 6.31016L12.0437 4.33203H9.5V6.31016ZM8.5 1.33203H7.5V3.33203H8.5V1.33203Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5872_15818">
          <rect width="16" height="16" fill="white" transform="translate(0 0.332031)" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5872_15818)">
        <path
          d="M6.5 1.33203C6.5 0.778906 6.94688 0.332031 7.5 0.332031H8.5C9.05313 0.332031 9.5 0.778906 9.5 1.33203V3.33203H12V1.83203C12 1.55703 12.225 1.33203 12.5 1.33203C12.775 1.33203 13 1.55703 13 1.83203V3.33203H13.4937H13.5031H15V1.83203C15 1.55703 15.225 1.33203 15.5 1.33203C15.775 1.33203 16 1.55703 16 1.83203V3.33203C16 3.88516 15.5531 4.33203 15 4.33203H13.6719L9.5 7.57578V15.832C9.5 16.107 9.275 16.332 9 16.332C8.725 16.332 8.5 16.107 8.5 15.832V7.33828V7.32891V4.33203H7.5V7.32891V7.33828V15.832C7.5 16.107 7.275 16.332 7 16.332C6.725 16.332 6.5 16.107 6.5 15.832V7.57578L2.32812 4.33203H1C0.446875 4.33203 0 3.88516 0 3.33203V1.83203C0 1.55703 0.225 1.33203 0.5 1.33203C0.775 1.33203 1 1.55703 1 1.83203V3.33203H2.49688H2.50625H3V1.83203C3 1.55703 3.225 1.33203 3.5 1.33203C3.775 1.33203 4 1.55703 4 1.83203V3.33203H6.5V1.33203ZM3.95625 4.33203L6.5 6.31016V4.33203H3.95625ZM9.5 6.31016L12.0437 4.33203H9.5V6.31016ZM8.5 1.33203H7.5V3.33203H8.5V1.33203Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5872_15818">
          <rect width="16" height="16" fill="white" transform="translate(0 0.332031)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default VPPIcon;
